<template>
  <DataTable
    loading-text="Загрузка данных..."
    no-data-text="Нет данных"
    v-bind.sync="props.tableModel.bind"
    v-on="props.tableModel.on"
    :page.sync="props.tableModel.bind.options.page"
    hide-default-footer
  >
    <template #item="{ item }">
      <tr>
          <td>{{ item.id }}</td>
          <td>{{ formatDateTimeNoTz(item.createdAt) }}</td>
          <td>{{ item.event?.name }}</td>
          <td>{{ item.madeBy?.username }}</td>
          <td>
            <eventStatus
              :isSuccess="item.success"
              :value="$t(item.success ? 'Успешно' : 'Неудачно')"
            />
          </td>
        <td>
          <v-menu transition="slide-x-transition"
            location="bottom left"
            :open-on-hover="true"
            :close-on-content-click="false"
          >
            <template #activator>
              <v-btn
                variant="text"
                class="px-0 action-button-color"
                icon="custom:eyeOutlineIcon"
                @click="viewLogs(item)"
              />
            </template>
          </v-menu>
        </td>
      </tr>
    </template>
  </DataTable>
  <Pagination 
    :page-sizes-list="props.pageSizesList"
    :table-model="props.tableModel"  
  />
</template>

<script setup lang="ts">
import { formatDateTimeNoTz } from "@/filters";
import eventStatus from '@/components/eventStatus.vue';
import Pagination from '@/components/Pagination.vue';
import DataTable from '@intec/vue-components/table/DataTable.vue'

const props = defineProps({
  pageSizesList: {
    type: Object,
    required: true
  },
  tableModel: {
    type: Object,
    required: true
  },
  confirmDlg: {
    type: Object,
    required: true
  },
});

const viewLogs = async (event) => {
  await props.confirmDlg.open(event.id);
};
</script>

<style lang="scss" scoped>
.action-button-color {
  color: rgb(var(--data-table-font-header-color));
}
</style>